const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  phone: state => state.user.phone,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  visitor: state => state.user.visitor,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  windSelectIndex: state => state.windState.windSelectIndex,
  windDataIsShow: state => state.windState.windDataIsShow,
}
export default getters
